import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Icon } from '../../components/Icon';
import { Button } from '../../components/primitives';
import { NAV_GROUP_LABEL, NAV_GROUP_ORDER, NAV_ITEMS, type NavItem } from '../../routes/navigation';

export interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

export function Sidebar({ collapsed, onToggle }: SidebarProps): JSX.Element {
  const { can } = useAuth();

  // El menú se construye desde los permisos efectivos: sin permiso, no se renderiza.
  const visible = NAV_ITEMS.filter((item) => item.permission === undefined || can(item.permission));

  const groups = NAV_GROUP_ORDER.map((group) => ({
    group,
    items: visible.filter((item) => item.group === group),
  })).filter((entry) => entry.items.length > 0);

  return (
    <nav className="sidebar" aria-label="Módulos de la plataforma">
      <div className="sidebar__brand">
        <span className="brand">
          <span className="brand__logo">
            OX<span>X</span>EAN
          </span>
        </span>
        {!collapsed && <span className="brand__text">People Analytics 360</span>}
      </div>

      <div className="sidebar__nav">
        {groups.map((entry) => (
          <div className="sidebar__group" key={entry.group}>
            <p className="sidebar__group-label">{NAV_GROUP_LABEL[entry.group]}</p>
            <ul>
              {entry.items.map((item) => (
                <li key={item.key}>
                  <SidebarLink item={item} collapsed={collapsed} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="sidebar__footer">
        <Button
          variant="ghost"
          size="sm"
          block
          onClick={onToggle}
          aria-expanded={!collapsed}
          aria-label={collapsed ? 'Expandir menú' : 'Colapsar menú'}
          style={{ color: 'var(--sidebar-ink)' }}
        >
          <Icon name={collapsed ? 'chevron-right' : 'chevron-left'} size={15} />
          {!collapsed && 'Colapsar'}
        </Button>
      </div>
    </nav>
  );
}

function SidebarLink({ item, collapsed }: { item: NavItem; collapsed: boolean }): JSX.Element {
  return (
    <NavLink
      to={item.path}
      end={item.path === '/'}
      className={({ isActive }) => `sidebar__link${isActive ? ' is-active' : ''}`}
      title={collapsed ? item.label : item.description}
    >
      <Icon name={item.icon} size={16} />
      <span className="sidebar__label">{item.label}</span>
    </NavLink>
  );
}
